import { getAdaptiveImg } from "@/utils/imageUrl";
import { openUdesk } from "@/utils/initUdesk";
import { Button } from "antd";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import HBPopover from "../HBPopover";
import Image from "../Image";
import styles from "./index.module.less";
/**
 * 单品类会员下载品类外素材是的提醒弹窗
 * @param {{
 *  currentVipType?: string;
 *  materialType?: string;
 *  onCancel?: () => void;
 * }} param
 * @returns
 */
function RawSingleCategoryModal({
  currentVipType,
  materialType,
  onCancel,
  ...props
}) {
  const isBigCompany = currentVipType === "bigCompany";

  return (
    <HBModal
      width={480}
      className={styles.singleCategoryModal}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      <div className={styles.title}>
        {isBigCompany
          ? `暂无法下载，请开通大企业${materialType}会员`
          : `未获得该类素材的使用权益，暂无法下载`}
      </div>
      <div>
        {isBigCompany ? (
          <div className={styles.desc}>
            您还不是大企业{materialType}会员，无法下载{materialType}
            类的素材，如需下载请联系客服开通对应会员。
          </div>
        ) : (
          <div className={styles.desc}>
            您是个人模板VIP，可下载使用平面模板和视频模板类的素材，不支持下载免抠元素、图片和实拍视频。如需更换套餐，请
            <a className="primary-text-btn" onClick={openUdesk}>
              联系客服
            </a>
          </div>
        )}
        <Image
          width={432}
          alt="示意图"
          src={getAdaptiveImg(
            "https://st0.dancf.com/static/02/202209020413-eb97.png",
            {
              width: 432,
              sharpen: 110,
              type: "png",
            }
          )}
        />
      </div>
      <div className={styles.footer}>
        <Button type={isBigCompany ? "default" : "primary"} onClick={onCancel}>
          我知道了
        </Button>
        {isBigCompany && (
          <HBPopover
            placement="top"
            content={
              <div className={styles.wxkfQrcode}>
                <div>添加客服微信</div>
                <div>会有专人为您服务</div>
                <Image
                  width={110}
                  alt="示意图"
                  src={getAdaptiveImg(
                    "https://grocery-cdn.huaban.com/file/2367c020-1d29-11ed-a8f4-b3a5c932ecac.png",
                    { width: 110, sharpen: 70, type: "png" }
                  )}
                />
              </div>
            }
          >
            <Button type="primary">联系客服开通</Button>
          </HBPopover>
        )}
      </div>
    </HBModal>
  );
}

/**单品类会员下载品类外素材是的提醒弹窗 */
const SingleCategoryModal = ModalWrap(RawSingleCategoryModal);

export default SingleCategoryModal;
